import styled from '@emotion/styled';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import ToggleButton from '@mui/material/ToggleButton';

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)({
  height       : '33px',
  borderRadius : '8px',
});

export const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  textTransform    : 'none',
  borderRadius     : '8px',
  '&.Mui-selected' : {
    backgroundColor : theme.palette.primary.greenPKD,
    '&:hover'       : {
      backgroundColor : theme.palette.primary.green,
    },
    color : theme.palette.primary.black,
  },
}));
